export const getApiUrl = (): string => {
    return process.env.REACT_APP_ENV === 'production' ? 'https://yingji.beyondh.com' : 'https://yingjitest.beyondh.com'
}